import React, { useState, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

export default function Stat(props) {
  const {plan, data} = props;

  const getPlanName = (plan) => {

    if(plan === 'su') {
      return 'Startup';
    } else if(plan === 'bu') {
      return 'Business';
    } else if(plan === 'pm') {
      return 'Premium';
    } else if(plan === 'et') {
      return 'Enterprise';
    } 
    return '';
  }

  if(!data) {
    return null;
  }

  return (
    <Card
    sx={{ height: '100%' }}
    {...props}
  >
    <CardContent>
      <Grid
        container
        spacing={3}
        sx={{ justifyContent: 'space-between' }}
      >
        <Grid item>
          <Typography
            color="textSecondary"
            gutterBottom
            variant="overline"
          >
            {getPlanName(plan)}
          </Typography>
          <Typography
            color="textPrimary"
            variant="h4"
          >
            {data.active}
          </Typography>
        </Grid>
        
      </Grid>
      <Box
        sx={{
          pt: 2,
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Typography
          color="textSecondary"
          variant="caption"
        >
          Active & Paid: {data.activeAndPaid}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Typography
          color="textSecondary"
          variant="caption"
        >
          Paid: {data.paid}
        </Typography>
        <Typography
          style={{paddingLeft:8}}
          color="textSecondary"
          variant="caption"
        >
          Total: {data.total}
        </Typography>
      </Box>
     
    </CardContent>
  </Card>
  )
};